import EventDispatcher from "../event-dispatcher";
import {
  Cluster,
  MarkerClusterer,
  SuperClusterAlgorithm,
} from "@googlemaps/markerclusterer";

declare var google: any;

const infoWindows: any[] = [];

const onDisplayMap = (map: any) => {
  google.maps.event.trigger(map, "resize");
};

const onDisplayListing = (map: any) => {};

const createMap = (mapElement: HTMLElement, options: any): any => {
  const mapOptions: any = {
    center: { lat: 54.445471, lng: -5.109225 },
    zoom: 5,
    mapId: options.mapId ?? 'DEMO_MAP_ID',
    ...options,
  };
  return new google.maps.Map(mapElement, mapOptions);
};

const placePropertyPins = (
  mapInstance: any,
  options: any,
  properties: any[],
  createMarker: (property: any) => any,
) => {
  const bounds = new google.maps.LatLngBounds();
  const markers: any[] = [];

  properties.forEach((property: any, index) => {
    if (!property.latitude || !property.longitude) {
        console.error("Property is missing lat or lng", property)
        return
    }
    const marker = createMarker(property);
    // Setting the bounds of the google map to the markers
    bounds.extend(marker.position);
    markers.push(marker);
  });

  if (properties.length > 0 && options.autoCenter != false) {
    mapInstance.fitBounds(bounds);
    if (properties.length == 1) {
      mapInstance.setZoom(15);
    }
  }

  return markers;
};

const addMarker = (
  mapInstance: any,
  options: any,
  property: any,
  position: any,
) => {
  const infoWindow = new google.maps.InfoWindow({
    content: property.description,
  });

    const customMarkerImg = document.createElement('img');
    customMarkerImg.src = options.marker.url
    customMarkerImg.setAttribute('data-description', property.description);
    if (options.marker.forceIconSize == "yes") {
        customMarkerImg.style.width = Number(options.marker.width || 71) + 'px';
        customMarkerImg.style.height = Number(options.marker.height || 81) + 'px';
    }
    customMarkerImg.style.zIndex = Number(options.marker.zIndex || 99999) + '';


  const markerOptions: any = {
    position: position,
    map: mapInstance,
    title: property.name,
    content: customMarkerImg,
  };
  const marker = new google.maps.marker.AdvancedMarkerElement(markerOptions);

  google.maps.event.addListener(marker, "click", () => {
    infoWindows.forEach((iw) => {
      iw.close();
    });
    infoWindow.open(mapInstance, marker);
  });
  infoWindows.push(infoWindow);

  return marker;
};

const createCustomMarkerHTML = (options: any, count: number) => {
    const customClusterMarkerImg = document.createElement('img');
    customClusterMarkerImg.src = options.clusterOptions.url + 1 + ".png";
    customClusterMarkerImg.style.width = options.clusterOptions.width + 'px';
    customClusterMarkerImg.style.height = options.clusterOptions.height + 'px';
    customClusterMarkerImg.style.gridArea = '1/1';

    const customClusterMarkerLabel = document.createElement('p');
    customClusterMarkerLabel.innerHTML = count.toString();
    customClusterMarkerLabel.style.gridArea = '1/1';
    customClusterMarkerLabel.style.fontSize = options.clusterOptions.fontSize;
    customClusterMarkerLabel.style.color = options.clusterOptions.textColor;
    customClusterMarkerLabel.style.height = '1em';
    customClusterMarkerLabel.style.margin = 'auto';
    customClusterMarkerLabel.style.textAlign = 'center';

    const customMarkerHTML = document.createElement('div');
    customMarkerHTML.style.display = 'grid';
    customMarkerHTML.style.placeContent = 'center';
    customMarkerHTML.style.width = options.clusterOptions.width + 'px';
    customMarkerHTML.style.height = options.clusterOptions.height + 'px';
    customMarkerHTML.innerHTML += customClusterMarkerImg.outerHTML;
    customMarkerHTML.innerHTML += customClusterMarkerLabel.outerHTML;

    return customMarkerHTML;
}

const enableClustering = (
  mapInstance: any,
  options: any,
  container: HTMLElement,
  markers: any[],
) => {
  const styles: any[] = [];

  options.clusterOptions =
    typeof options.clusterOptions === "undefined" ? {} : options.clusterOptions;
  options.clusterOptions.width =
    typeof options.clusterOptions.width === "undefined"
      ? 56
      : options.clusterOptions.width;
  options.clusterOptions.height =
    typeof options.clusterOptions.height === "undefined"
      ? 56
      : options.clusterOptions.height;

  options.clusterOptions.url =
    typeof options.clusterOptions.url !== "undefined"
      ? options.clusterOptions.url + ".png"
      : "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m";

  styles.push(options.clusterOptions);

  google.maps.event.addListener(mapInstance, "idle", () => {
    const renderer = {
      render: function ({ count, position }: any) {
        return new google.maps.marker.AdvancedMarkerElement({
          map: mapInstance,
          position,
          content: createCustomMarkerHTML(options, count),
        });
      },
    };

    const cluster: MarkerClusterer = new MarkerClusterer({
      markers,
      map: mapInstance,
      renderer: renderer,
      onClusterClick: (event, clickedCluster, map) => {
        return onClusterClick(event, clickedCluster, map, container);
      },
      algorithm: new SuperClusterAlgorithm({ maxZoom: 30 }),
    });
  });
};

const onClusterClick = (
  event: google.maps.MapMouseEvent,
  clickedCluster: Cluster,
  map: google.maps.Map,
  container: HTMLElement,
) => {
  event.stop();

  if (map.getZoom() < 16) {
    map.fitBounds(clickedCluster.bounds);
    return;
  }

  const infoWindow = new google.maps.InfoWindow();
  infoWindow.setContent(
    '<div class="clustered-group">' +
      clickedCluster.markers.reduce((output: any, marker: any) => {
        const description = marker.content.getAttribute('data-description');
        return output + `<div class="property">${description}</div>`;
      }, "") +
      "</div>",
  );
  infoWindow.setPosition(clickedCluster.position);
  infoWindow.open(map);
  infoWindows.push(infoWindow);
  EventDispatcher.emit(container, "properties.map.cluster.click");
};

export default {
  onDisplayMap,
  onDisplayListing,
  createMap,
  placePropertyPins,
  addMarker,
  enableClustering,
};
